import { connect } from "react-redux";

import {
  addClientLocation,
  getClientLocation,
  updateClientLocation,
  createClient,
  getClientShortList,
} from "../../ClientsNew/clientsActions";
import { getTaskType } from "../../Jobs/tasksActions";
import {
  createOrgLocation,
  getOrganizationLocations,
} from "../../Organization/OrganizationActions";
import { getOrganizationMembersShortList } from "../../Projects/projectsActions";
import { createJobRequest, getWorkOrderShortList } from "../workOrderActions";
// Component
import CreateJobPopupNew from "./CreateJobPopupNew";

// Store props to map with current state
const mapStateToProps = state => ({
  selectedOrganization: state.organization.selectedOrganization,
  orgMembersShortList: state.project.orgMembersShortList,
  memberShortListIsLoading: state.project.memberShortListIsLoading,
  taskTypeList: state.task.taskTypeList,
  //workordershort
  workOrderShortList: state.workorder.workOrderShortList,
  //Customer Location
  clientLocationList: state.client.clientLocationList,
  getclientLocalMapLoading: state.client.getclientLocalMapLoading,
  addOrUpdateclientLocalMapLoading:
    state.client.addOrUpdateclientLocalMapLoading,
  createdClientLocationInfo: state.client.createdClientLocationInfo,
  //Organization Location
  organizationLocationList: state.organization.organizationLocationList,
  getOrganizationLocationLoading:
    state.organization.getOrganizationLocationLoading,
  addOrgLocationLoading: state.organization.addOrgLocationLoading,
  createdOrgLocationInfo: state.organization.createdOrgLocationInfo,
  //job
  createdJob: state.workorder.createdJob,
  createOrUpdateJobIsLoading: state.workorder.createOrUpdateJobIsLoading,
  isJobLimitFull: state.workorder.isJobLimitFull,
  //client
  clientShortList: state.client.clientShortList,
  isClientLoading: state.client.isClientLoading,
  createdClientId: state.client.createdClientId,
  createdClientInfo: state.client.createdClientInfo,
});

// Actions prop to dispatch
const mapDispatchToProps = dispatch => ({
  getOrganizationMembersShortList: params =>
    dispatch(getOrganizationMembersShortList(params)),
  getTaskType: params => dispatch(getTaskType(params)),
  getWorkOrderShortList: params => dispatch(getWorkOrderShortList(params)),
  getClientLocation: details => dispatch(getClientLocation({ ...details })),
  addClientLocation: details => dispatch(addClientLocation({ ...details })),
  updateClientLocation: details =>
    dispatch(updateClientLocation({ ...details })),
  getOrganizationLocations: details =>
    dispatch(getOrganizationLocations({ ...details })),
  createOrgLocation: details => dispatch(createOrgLocation({ ...details })),
  createJobRequest: details => dispatch(createJobRequest({ ...details })),
  createClient: details => dispatch(createClient({ ...details })),
  getClientShortList: details => dispatch(getClientShortList({ ...details })),
});

// connect states and dispatchers with components
export default connect(mapStateToProps, mapDispatchToProps)(CreateJobPopupNew);
